import type { ReactNode } from "react";

import styles from "./style.module.scss";

interface PermissionSectionProps {
    title: string;
    children: ReactNode;
}

const PermissionSection = ({ title, children }: PermissionSectionProps) => {
    return (
        <div className={styles["permission-section"]}>
            <h5 className={styles["section-title"]}>{title}</h5>
            <div className={styles["section-content"]}>{children}</div>
        </div>
    );
};

export default PermissionSection;
